/**
 * "Hindupur " -> "hindupur": the URL form of a doctor's free-text `city`, for
 * /doctors/:city. scripts/sitemap.js carries a copy (it runs in plain Node,
 * outside the bundle); src/sitemapScript.test.js fails if the two disagree.
 */
export function citySlug(city) {
  return String(city ?? '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
}

export default citySlug;
